<template>
  <q-page padding>
    <div
      class="row col-12 text-brand-5"
      style="cursor: pointer"
      @click="voltar()"
    >
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />
      <p class="text-h6 text-brand-1 text-weight-bold texto-titulo">
        Editar Nota #{{ notaId }}
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Status</div>
        <q-input
          v-model="notaDetalhes.status"
          disable
          dense
          outlined
          bg-color="brand-7"
          class="input input-new-design"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Num. Solicitação Compra</div>
        <q-input
          v-model="dados.solicitacaoCompra"
          dense
          @change="editarDadosNota"
          outlined
          class="input input-new-design"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Num. Pedido Compra</div>
        <q-input
          @change="editarDadosNota"
          v-model="dados.pedidoCompra"
          dense
          outlined
          class="input input-new-design"
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Data do Recebimento</div>
        <q-input
          mask="##/##/####"
          v-model="dataAtual"
          dense
          outlined
          class="input input-new-design"
        />
      </div>
      <div class="col-md-1 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Num. NF</div>
        <q-input
          v-model="notaDetalhes.numero"
          disable
          bg-color="brand-7"
          dense
          outlined
          class="input input-new-design"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Data Emissao</div>
        <q-input
          mask="##/##/####"
          v-model="dataEmissao"
          dense
          outlined
          class="input input-new-design"
          disable
          bg-color="brand-7"
        />
      </div>
      <div class="textArea q-mt-sm">
        <div class="q-ml-sm texto-titulo-input">Fornecedor</div>
        <q-input
          v-model="dados.fornecedor"
          dense
          outlined
          class="input"
          readonly
          bg-color="brand-7 input-new-design"
        />
      </div>
      <div class="textArea q-mt-sm">
        <div class="q-ml-sm texto-titulo-input">
          Informações Complementares da Nota
        </div>
        <q-input
          v-model="dados.infosComplementares"
          readonly
          outlined
          type="textarea"
          class="input"
          bg-color="brand-7 input-new-design"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns"
        :rows="notaDetalhes.products"
        :loading="loading"
        dense
        color="primary"
        class="tabela-tamanho-fixo"
        :rows-per-page-options="[0]"
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        flat
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos da Nota Fiscal.</span
          >
        </template>

        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-9">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong
                    >{{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Código Fornecedor: </strong
                    >{{ props.row.codigo_produto }}</span
                  >
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cod. Interno: </strong>
                    <input
                      v-model="props.row.product_code"
                      type="text"
                      class="input-grid"
                      :disable="props.row.pedidos.length != 0"
                    />
                  </span>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Item: </strong
                    >{{ getProductDescription(props.row) }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Pedido em Aberto: </strong>
                    <span
                      v-for="(aberto, index) in props.row.em_aberto.ordens"
                      :key="index"
                      style="width: 250px"
                      class="row justify-between no-wrap q-mt-sm"
                      v-show="props.row.em_aberto.length != 0"
                    >
                      <span
                        style="
                          width: 240px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        "
                      >
                        Pedido num: {{ aberto.purchase_order_id }} - A receber:
                      </span>

                      <span>
                        {{
                          toNumber(aberto.quantidade_pedido) -
                          toNumber(aberto.quantidade_vinculada)
                        }}
                        <q-btn
                          style="font-size: 10px"
                          icon="add"
                          color="positive"
                          flat
                          size="sm"
                          round
                          @click="vincular(props.row.uuid, aberto, props.row)"
                        />
                      </span>
                      <br />
                    </span>
                    <span v-if="props.row.em_aberto.length == 0"
                      >Não existe pedido em <br />
                      aberto para este produto<br />
                      neste fornecedor!</span
                    ></span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Pedido Assosiado: </strong>
                    <span
                      v-for="(pedido, index) in props.row.pedidos"
                      :key="index"
                      style="width: 225px"
                      class="row justify-between no-wrap align q-mt-sm"
                      v-show="props.row.pedidos.length != 0"
                    >
                      Pedido num: {{ pedido.purchase_order_id }} - Qtdade:
                      {{ toNumber(pedido.quantidade) }}
                      <span>
                        <q-btn
                          style="font-size: 10px"
                          icon="remove"
                          color="negative"
                          flat
                          size="sm"
                          round
                          @click="desvincular(props.row.uuid, pedido)"
                        />
                      </span>
                    </span>
                    <span v-if="props.row.pedidos.length == 0"
                      >Sem Associado</span
                    ></span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Quantidade NF: </strong
                    >{{ props.row.quantidade_comercial }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Unidade NF: </strong
                    >{{ props.row.business_unity }}</span
                  >
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Quantidade Recebida: </strong>

                    <input
                      v-model="props.row.business_amount"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                  <span class="row col-12 q-ml-sm items-center q-mt-sm"
                    ><strong class="q-mr-xs">{{ loteLabel }}: </strong
                    ><input
                      v-model="props.row.lote"
                      type="text"
                      class="input-grid"
                  /></span>
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Validade: </strong>

                    <input
                      v-model="props.row.validade"
                      type="text"
                      class="input-grid"
                    />
                  </span>
                </div>
                <div class="row col-3 justify-around">
                  <div>
                    <q-btn
                      v-if="!props.selected"
                      icon="edit"
                      color="primary"
                      round
                      @click="
                        (props.selected = true), recebeDadosEditar(props.row)
                      "
                    />
                    <q-btn
                      v-else
                      icon="done"
                      color="positive"
                      round
                      @click="editarDadosProduto()"
                    />
                  </div>
                  <div>
                    <q-btn icon="delete" color="red" round />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              <span v-if="col.name != 'lote'">{{ col.label }}</span>
              <div style="align-items: center" class="row" v-else>
                {{ col.label }}
                <q-btn
                  @click="confirmDialog = !confirmDialog"
                  icon="sym_o_edit"
                  round
                  size="sm"
                  color="primary"
                  flat
                />
              </div>
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td class="text-center">
              <q-btn
                flat
                dense
                round
                size="sm"
                icon="print"
                color="primary"
                @click="imprimirEtiqueta(props.row)"
              >
                <q-tooltip>Imprimir Etiqueta</q-tooltip>
              </q-btn>
            </q-td>
            <q-td>
              <span> {{ props.row.id }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.codigo_produto }}</span>
            </q-td>
            <q-td>
              <q-input
                dense
                :disable="props.row.pedidos.length != 0"
                outlined
                v-model="props.row.product_code"
                style="width: 100px"
              />
            </q-td>
            <q-td>
              <span> {{ getProductDescription(props.row) }}</span>
            </q-td>
            <q-td>
              <span
                v-for="(aberto, index) in props.row.em_aberto.ordens"
                :key="index"
                style="width: 250px"
                class="column justify-between no-wrap q-mt-sm"
                v-show="props.row.em_aberto.length != 0"
              >
                <span
                  style="
                    width: 240px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  Pedido num: {{ aberto.purchase_order_id }} - A receber:
                </span>

                <span>
                  {{
                    toNumber(aberto.quantidade_pedido) -
                    toNumber(aberto.quantidade_vinculada)
                  }}
                  <q-btn
                    style="font-size: 10px"
                    icon="add"
                    color="positive"
                    flat
                    size="sm"
                    round
                    @click="vincular(props.row.uuid, aberto, props.row)"
                  />
                </span>
                <br />
              </span>
              <span v-if="props.row.em_aberto.length == 0"
                >Não existe pedido em <br />
                aberto para este produto<br />
                neste fornecedor!</span
              >
            </q-td>

            <q-td>
              <span
                v-for="(pedido, index) in props.row.pedidos"
                :key="index"
                style="width: 225px"
                class="row justify-between no-wrap align q-mt-sm"
                v-show="props.row.pedidos.length != 0"
              >
                Pedido num: {{ pedido.purchase_order_id }} - Qtdade:
                {{ toNumber(pedido.quantidade) }}
                <span>
                  <q-btn
                    style="font-size: 10px"
                    icon="remove"
                    color="negative"
                    round
                    flat
                    size="sm"
                    @click="desvincular(props.row.uuid, pedido)"
                  />
                </span>
              </span>
              <span v-if="props.row.pedidos.length == 0">Sem Associado</span>
            </q-td>
            <q-td>
              <span> {{ props.row.quantidade_comercial }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.business_unity }}</span>
            </q-td>
            <q-td>
              <q-input
                dense
                outlined
                v-model="props.row.business_amount"
                style="width: 100px"
              />
            </q-td>
            <q-td>
              <span>
                {{ props.row.product?.stock[0]?.pivot?.measurement_unit }}</span
              >
            </q-td>
            <q-td>
              <span>
                {{ props.row.product?.stock[0]?.pivot?.measurement_unit }}</span
              >
            </q-td>
            <q-td>
              <q-input
                style="width: 100px"
                dense
                outlined
                v-model="props.row.lote"
              />
            </q-td>
            <q-td>
              <q-input
                dense
                outlined
                v-model="props.row.validade"
                style="width: 100px"
              />
            </q-td>
            <q-td>
              <span> {{ formatarValor(props.row.business_unity_value) }}</span>
            </q-td>
            <q-td>
              <span>
                {{
                  calcularTotalRecebido(
                    props.row.business_amount,
                    props.row.business_unity_value
                  )
                }}</span
              >
            </q-td>
            <q-td>
              <q-btn
                icon="done"
                color="positive"
                round
                @click="editarDadosProduto(props.row)"
              />
            </q-td>
            <!-- <q-td>
              <q-btn icon="qr_code" color="blue-6" round />
            </q-td> -->
            <q-td>
              <q-btn
                icon="delete"
                color="red"
                round
                @click="deletarProduto(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div
        v-if="notaDetalhes.status != 'Finalizado'"
        class="row col-12 justify-start q-ml-md q-mt-lg btn-container"
      >
        <q-btn
          label="Finalizar Entrada"
          no-caps
          style="background-color: #304f78; border-radius: 8px; color: white"
          icon="done"
          class="btn"
          @click="receberDadosEntrada()"
        />
      </div>
    </div>
    <div class="q-mt-xl carrossel-desktop">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Imagens do Recebimento
        </span>
      </div>
      <div class="row col-12 q-mt-md">
        <div v-if="imagensNota.length > 0" class="col-6 justify-center">
          <div class="col-12 q-pa-md">
            <q-carousel
              v-model:fullscreen="fullscreen"
              animated
              v-model="slide"
              arrows
              height="200px"
              control-type="regular"
              infinite
              control-color="brand-1"
            >
              <q-carousel-slide
                v-for="(imagem, index) in imagensNota"
                :key="index"
                :name="index"
                :img-src="
                  imagem.url.indexOf('pdf') != -1
                    ? require('../../../../assets/pdfIcon.png')
                    : imagem.url.indexOf('xml') != -1
                    ? require('../../../../assets/exelIcon.png')
                    : imagem.url
                "
              />
              <template v-slot:control>
                <q-carousel-control position="bottom-right" :offset="[7, 18]">
                  <q-btn
                    push
                    round
                    dense
                    color="white"
                    text-color="primary"
                    :icon="fullscreen ? 'fullscreen_exit' : 'fullscreen'"
                    @click="fullscreen = !fullscreen"
                  />
                </q-carousel-control>
                <q-carousel-control
                  position="bottom-left"
                  :offset="[1, 18]"
                  class="q-gutter-xs"
                >
                  <q-btn
                    push
                    round
                    dense
                    flat
                    color="red"
                    icon="delete"
                    @click="recebeImagemUuid(slide)"
                  />
                </q-carousel-control>
              </template>
            </q-carousel>
          </div>
        </div>
        <div class="row col-2 items-center">
          <div class="col-12">
            <label
              class="btn info row col-12 justify-center"
              for="arquivo"
              style="cursor: pointer"
            >
              <p class="text-brand-5 text-weight-bold">Subir Nova Imagem</p>
              <div class="row col-12 justify-center">
                <q-btn
                  icon="upload"
                  size="lg"
                  round
                  color="primary"
                  style="z-index: -1"
                />
              </div>
            </label>
            <input id="arquivo" type="file" @change="onFileSelected" />
          </div>
        </div>
      </div>
    </div>
    <div class="q-mt-xl carrossel-mobile">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Imagens do Recebimento
        </span>
      </div>
      <div class="row col-12 q-mt-md">
        <div v-if="imagensNota.length > 0" class="col-12 justify-center">
          <div class="col-12 q-pa-md">
            <q-carousel
              v-model:fullscreen="fullscreen"
              animated
              v-model="slide"
              infinite
              arrows
              style="height: 200px"
            >
              <q-carousel-slide
                v-for="(imagem, index) in imagensNota"
                :key="index"
                :name="index"
                :img-src="imagem.url"
              />
              <template v-slot:control>
                <q-carousel-control
                  position="bottom-left"
                  :offset="[1, 18]"
                  class="q-gutter-xs"
                >
                  <q-btn
                    push
                    round
                    dense
                    flat
                    color="red"
                    icon="delete"
                    @click="recebeImagemUuid(slide)"
                  />
                </q-carousel-control>
              </template>
            </q-carousel>
          </div>
        </div>
        <div class="row col-12">
          <div class="col-12">
            <label
              class="btn info row col-12 justify-end"
              for="arquivo"
              style="cursor: pointer"
            >
              <div class="row col-12 justify-end">
                <q-btn
                  icon="upload"
                  label="Selecionar Arquivo"
                  color="primary"
                  style="z-index: -1"
                  class="btn"
                  no-caps
                />
              </div>
            </label>
            <input id="arquivo" type="file" @change="onFileSelected" />
          </div>
        </div>
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Histórico
        </span>
      </div>
      <q-table
        :columns="columns2"
        :rows="historicoItems"
        color="primary"
        class="tabela-tamanho-fixo"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        dense
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-6">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Ação: </strong>
                    {{ props.row.acao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Usuário: </strong>
                    {{ props.row.usuario }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Criado Em: </strong>
                    {{ formatarData(props.row.data) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-acao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.acao }}
          </q-td>
        </template>
        <template v-slot:body-cell-usuario="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.usuario }}
          </q-td>
        </template>
        <template v-slot:body-cell-criado="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ formatarData(props.row.data) }}
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja adicionar essa imagem?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="adicionarImagem()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="deletar" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja deletar essa imagem?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="deletarImagemNota()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <dialog-info-design
      class="row col-12"
      mensagem="Lotes a serem preenchidos"
      subMensagem="Digite o nome do lote para preencher todas as colunas automaticamente."
      :exibir="confirmDialog"
      @resultado="preencherLotes"
    >
      <div>
        <div class="q-ml-sm texto-titulo-input">Digite o Lote</div>
        <q-input
          v-model="loteGeral"
          dense
          outlined
          class="input input-new-design"
        />
      </div>
    </dialog-info-design>
  </q-page>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";
import DialogInfoDesign from "../components/DialogInfoDesign.vue";

const columns2 = [
  {
    name: "acao",
    label: "Ação",
    align: "left",
  },
  {
    name: "usuario",
    label: "Usuário",
    align: "left",
  },
  {
    name: "criado",
    label: "Criado Em",
    align: "left",
  },
];
export default {
  components: {
    DialogInfoDesign,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();
    const notaId = route.params.notaId;
    const notaDetalhes = ref("");
    const confirmDialog = ref(false);
    const loteGeral = ref("");
    const dados = ref({
      fornecedor: "",
      infosComplementares: "",
      pedidoCompra: "",
      solicitacaoCompra: "",
    });
    const dadosProduto = ref({
      validade: "",
      codigoInterno: "",
      quantidadeRecebida: "",
      produtoId: "",
      businessUnity: "",
    });
    const dataAtual = new Date().toLocaleString("pt-br").split(" ")[0];
    const dataEmissao = ref("");
    const selected = ref([]);
    const imagensNota = ref([]);
    const imagemUiid = ref("");
    const file = ref(null);
    const imageUrl = ref("");
    let confirm = ref(false);
    let deletar = ref(false);
    let loading = ref(false);
    let slide = ref(0);

    const detalharNota = async () => {
      try {
        slide.value = 0;
        imagensNota.value = [];
        loading.value = true;
        const response = await store.dispatch("notaFiscal/editarNota", {
          nota_id: notaId,
          initial_date: "01/01/2017",
        });
        notaDetalhes.value = response.data.model;
        dataEmissao.value = notaDetalhes.value.data_emissao
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/");
        dados.value = {
          fornecedor: notaDetalhes.value.provider.business_name,
          infosComplementares: notaDetalhes.value.informacoes_complementares,
          pedidoCompra: notaDetalhes.value.pedido_compra,
          solicitacaoCompra: notaDetalhes.value.solicitacao_compra,
        };
        if (notaDetalhes.value.products) {
          notaDetalhes.value.products.forEach((produto) => {
            produto.validade = "31/12/2025";
            // busca o lote do array lotes se existir
            if (produto.lotes && produto.lotes.length > 0) {
              produto.lote = produto.lotes[0].lote || "";
            } else if (!produto.lote) {
              produto.lote = "";
            }
          });
        }
        if (notaDetalhes.value.imagens) {
          notaDetalhes.value.imagens.forEach((imagem) => {
            if (imagem.deleted_at == null) {
              imagensNota.value.push(imagem);
            }
          });
        }
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const recebeImagemUuid = (index) => {
      if (index >= 0 && index < imagensNota.value.length) {
        imagemUiid.value = imagensNota.value[index].uuid;
        deletar.value = true;
      }
    };

    const deletarImagemNota = async () => {
      try {
        await store.dispatch("notaFiscal/deletarImagemNota", {
          uuid: imagemUiid.value,
        });
        detalharNota();
        quasar.notify({
          message: "Imagem deletada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao deletar imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
      confirm.value = true;
    };

    const adicionarImagem = async () => {
      try {
        await store.dispatch("notaFiscal/adicionarImagem", {
          imagem: imageUrl.value,
          nf_id: notaId,
        });
        detalharNota();
        quasar.notify({
          message: "Imagem adicionada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao adicionar imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const recebeDadosEditar = (row) => {
      dadosProduto.value = {
        validade: row.validade,
        codigoInterno: row.product_code,
        quantidadeRecebida: row.business_amount,
        produtoId: row.id,
        businessUnity: parseInt(row.business_unity_value),
      };
    };

    const editarDadosNota = async () => {
      try {
        await store.dispatch("notaFiscal/editarDadosNota", {
          nf_id: notaId,
          pedido_compra: dados.value.pedidoCompra,
          solicitacao_compra: dados.value.solicitacaoCompra,
        });
      } catch (error) {
        console.log(error);
      }
    };

    const editarDadosProduto = async (row) => {
      try {
        await store.dispatch("notaFiscal/editarDadosProduto", {
          nf_id: notaId,
          product_id: row.id,
          business_amount: row.business_amount,
          business_value: row.business_unity,
          product_code: row.product_code,
          validade: row.validade,
        });
        quasar.notify({
          message: "Dados do produto atualizados com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        selected.value = [];
        detalharNota();
      } catch (error) {
        if (error.response.data.errors.product_code) {
          quasar.notify({
            message: `Erro ao atualizar, código ${dados.value.codigoInterno} não encontrado, verifique todos os códigos internos digitados!`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        quasar.notify({
          message: "Erro ao atualizar dados do produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberDadosEntrada = async () => {
      let produtosNota = [];

      await notaDetalhes.value.products.forEach((produto) => {
        produtosNota.push(produto);
        finalizarEntrada(produto);
      });
      await finalizarNota(produtosNota);
      detalharNota();
    };

    const finalizarNota = async (produtosNota) => {
      try {
        const batchesValidos = produtosNota
          .filter((value) => {
            const lote = value.lote;
            return (
              lote !== undefined &&
              lote !== null &&
              lote !== "" &&
              String(lote).trim() !== "" &&
              String(lote).trim() !== "0"
            );
          })
          .map((value) => ({
            batch: value.lote,
            product_code: value.product_code,
            amount: value.business_amount,
            expiration_date: "31/12/2099",
          }));

        await store.dispatch("notaFiscal/finalizarNota", {
          nf_id: notaId,
          batches: batchesValidos,
        });

        quasar.notify({
          message: "Nota finalizada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao finalizar nota",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const finalizarEntrada = async (produto) => {
      try {
        await store.dispatch("notaFiscal/editarDadosProduto", {
          nf_id: notaId,
          product_id: produto.id,
          business_amount: produto.business_amount,
          business_value: parseInt(produto.business_unity_value),
          product_code: produto.product_code,
        });
        await detalharNota();

        quasar.notify({
          message: "Dados do produto atualizados com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        if (error?.response?.data?.errors?.product_code) {
          quasar.notify({
            message: `Erro ao atualizar, código ${produto.product_code} não encontrado, verifique todos os códigos internos digitados!`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        quasar.notify({
          message: "Erro ao atualizar dados do produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletarProduto = async (produtoId) => {
      try {
        await store.dispatch("notaFiscal/deletarProduto", {
          product_id: produtoId,
          nf_id: notaId,
        });
        detalharNota();
        quasar.notify({
          message: "Produto deletado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao deletar produto",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = () => {
      router.push({ name: "nf-lista" });
    };

    watch(
      () => file.value,
      () => {
        if (file.value != null) {
          let fileReader = new FileReader();

          fileReader.readAsDataURL(file.value);
          fileReader.addEventListener("load", () => {
            imageUrl.value = fileReader.result;
          });
        }
      }
    );

    const toNumber = (value) => parseFloat(String(value).replace(",", "."));

    const getProductDescription = (produto) => {
      const contractDescription =
        produto.product?.contracts?.[0]?.pivot?.contract_product_description;
      if (contractDescription) {
        return contractDescription;
      }

      if (produto.product?.description) {
        return produto.product.description;
      }

      return produto.descricao || "";
    };

    const formatarValor = (value) => {
      const numero =
        typeof value === "string"
          ? parseFloat(value.replace(/,/g, "."))
          : parseFloat(value);

      if (isNaN(numero)) return "0.0000";

      return numero.toFixed(4);
    };

    const calcularTotalRecebido = (quantidadeRecebida, valorUnitario) => {
      const quantidade =
        typeof quantidadeRecebida === "string"
          ? parseFloat(quantidadeRecebida.replace(/,/g, "."))
          : parseFloat(quantidadeRecebida);

      const valor =
        typeof valorUnitario === "string"
          ? parseFloat(valorUnitario.replace(/,/g, "."))
          : parseFloat(valorUnitario);

      if (isNaN(quantidade) || isNaN(valor)) return "0.0000";

      return (quantidade * valor).toFixed(4);
    };

    const vincular = async (id, pedido, row) => {
      let quantidadeVinculada = 0;
      let limiteEnvio = toNumber(row.business_amount);
      let pedidoQuantidadeEnvio =
        toNumber(pedido.quantidade_pedido) -
        toNumber(pedido.quantidade_vinculada);

      row.pedidos.forEach((value) => {
        quantidadeVinculada += toNumber(value.quantidade);
      });

      if (limiteEnvio - quantidadeVinculada <= 0) {
        quasar.notify({
          message: "Quantidade máxima de pedidos associados atingida",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        return;
      }

      if (limiteEnvio - quantidadeVinculada < pedidoQuantidadeEnvio) {
        pedidoQuantidadeEnvio = limiteEnvio - quantidadeVinculada;
      }

      try {
        await store.dispatch("notaFiscal/vincularPedido", {
          uuid_item_nf: id,
          quantidade: pedidoQuantidadeEnvio,
          uuid_item_pedido: pedido.uuid_item_pedido,
        });

        quasar.notify({
          message: "Vinculado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
        detalharNota();
      } catch (error) {
        quasar.notify({
          message:
            "Erro ao associar pedido, verifique se o status do pedido é ENVIADO!",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      }
    };

    const desvincular = async (id, pedido) => {
      try {
        await store.dispatch("notaFiscal/desvincularPedido", {
          uuid_item_nf: id,
          uuid_item_pedido: pedido.uuid_item_pedido,
        });

        quasar.notify({
          message: "Desvinculado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        detalharNota();
      } catch (error) {
        quasar.notify({
          message: "Erro ao desvincular!",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const imprimirEtiqueta = (row) => {
      const routeData = router.resolve({
        name: "ind-estoque-etiqueta",
        query: {
          codigo: row.product_code || row.codigo_produto || "",
          descricao: getProductDescription(row),
          unidade: row.product?.stock?.[0]?.pivot?.measurement_unit || row.business_unity || "",
        },
      });
      window.open(routeData.href, "_blank");
    };

    onMounted(detalharNota);

    const preencherLotes = async () => {
      confirmDialog.value = false;
      notaDetalhes.value.products = notaDetalhes.value.products.map((value) => {
        return {
          ...value,
          lote: loteGeral.value,
        };
      });
    };

    const formatarData = (dataString) => {
      if (!dataString) return "";

      try {
        let dataLimpa = dataString
          .toString()
          .replace("T", " ")
          .replace(/Z.*$/, "");

        if (dataLimpa.includes("-") && dataLimpa.includes(" ")) {
          const [data, hora] = dataLimpa.split(" ");
          const [ano, mes, dia] = data.split("-");
          const horarioFormatado = hora.split(".")[0];
          return `${dia}/${mes}/${ano} ${horarioFormatado}`;
        }

        return dataString.toString();
      } catch (error) {
        console.log(error);
        return dataString.toString();
      }
    };

    const historicoItems = computed(() => {
      if (!notaDetalhes.value) return [];

      const usuarios = notaDetalhes.value.usuario_operacao || [];
      if (usuarios.length === 0) return [];

      return usuarios
        .map((usuario) => ({
          acao: usuario?.pivot?.operacao || "",
          usuario: usuario?.name || "Sistema",
          data: usuario?.pivot?.created_at || "",
        }))
        .sort((a, b) => new Date(a.data) - new Date(b.data));
    });

    const isAccionaTenant = computed(() => {
      const cliente = store.state.autenticacao?.cliente || "";
      return cliente.includes("acciona") || cliente.includes("staging-acciona");
    });

    const loteLabel = computed(() => {
      return isAccionaTenant.value ? "Localização" : "Lote";
    });

    const columns = computed(() => [
      {
        name: "etiqueta",
        label: "Etiqueta",
        align: "center",
        style: "width: 50px",
      },                                                                
      {
        name: "id",
        label: "ID",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "codigoFornecedor",
        label: "Código Fornecedor",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "codigoInterno",
        label: "Código Interno",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "item",
        label: "Item",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "pedidoAberto",
        label: "Pedido em Aberto",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "pedidoAssociado",
        label: "Pedido Associado",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "quantidadeNf",
        label: "Quantidade NF",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "unidadeNf",
        label: "Unidade NF",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "quantidadeRecebida",
        label: "Quantidade Recebida",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "unidadeCatalogo",
        label: "Unidade Catálogo",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "descUnidade",
        label: "Desc. Unidade",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "lote",
        label: loteLabel.value,
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "validade",
        label: "Validade",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "unitario",
        label: "R$ Unitário",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "totalRecebido",
        label: "Total Recebido",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "editar",
        label: "Editar",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "deletar",
        label: "Deletar",
        align: "left",
      },
    ]);

    return {
      columns2,
      columns,
      notaId,
      detalharNota,
      notaDetalhes,
      dataAtual,
      desvincular,
      dataEmissao,
      dados,
      selected,
      slide,
      fullscreen: ref(false),
      imagensNota,
      deletarImagemNota,
      imagemUiid,
      onFileSelected,
      file,
      imageUrl,
      recebeImagemUuid,
      adicionarImagem,
      confirm,
      deletar,
      editarDadosNota,
      recebeDadosEditar,

      preencherLotes,
      editarDadosProduto,
      finalizarEntrada,
      receberDadosEntrada,
      voltar,
      dadosProduto,
      loading,
      deletarProduto,
      vincular,
      confirmDialog,
      loteGeral,
      formatarData,
      historicoItems,
      toNumber,
      formatarValor,
      calcularTotalRecebido,
      loteLabel,
      isAccionaTenant,
      getProductDescription,
      imprimirEtiqueta,
    };
  },
};
</script>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>

<style scoped>
input[type="file"] {
  display: none;
}

.q-carousel__slide {
  background-size: contain;
  background-repeat: no-repeat;
}

.align {
  align-items: center;
}

.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.cursor {
  cursor: pointer;
}
.textArea {
  width: 95%;
}
.carrossel-mobile {
  display: none;
}
.texto-titulo-input {
  color: #21324a;
}
@media (max-width: 600px) {
  .cursor {
    font-size: 14px !important;
    margin-top: 18px !important;
  }
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
    color: #21324a;
  }
  .textArea {
    width: 94%;
  }
  .input {
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .input-grid {
    width: 70px;
    outline: none;
  }
  .btn-container {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
    justify-content: end;
  }
  .btn {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
  }
  .carrossel-desktop {
    display: none;
  }
  .carrossel-mobile {
    display: initial;
  }
}
</style>
